import { get } from "../../../../common/utils/index.js";
import * as DashboardType from "../../actiontype/DashboardType/Dashboard.jsx";

export const onJustReducerUpdate = (payload, reducerType) => {
    return ({ type: reducerType, payload })
  }

export const dashboardCall = (showToast,showLoader, hideLoader) => (dispatch) => {
    showLoader();
    dispatch({ type: DashboardType.DASHBOARD_REQUEST })
    // get('/users')
    //     .then(res => {
    //         hideLoader();
    //         // showToast('success','Success', 'Updated the Record Successfully');
    //         dispatch({ type: DashboardType.DASHBOARD_SUCCESS, payload: res })
    //     })
    //     .catch(err => {
    //         hideLoader();
    //         // showToast('error','Error', "Error Handled");
    //         dispatch({ type: DashboardType.DASHBOARD_FAILURE, payload: err?.message })
    //     })
}
